// ante-react-kit/src/components/AntQuickPopup/QuickPopupStackManager.js
import React, { useEffect, useState, useCallback } from 'react';
import QuickPopupRegistry from './QuickPopupRegistry';

let _idSeq = 1;
const _listeners = new Set();
let _stack = [];  // [{ id, table, props }]

const StackAPI = {
    open(table, props = {}) {
        const reg = QuickPopupRegistry.get(table);
        if (!reg) {
            console.warn('[QuickPopup] no registered popup for table:', table);
            return null;
        }
        const id = _idSeq++;
        _stack = [..._stack, { id, table, props }];
        _listeners.forEach((fn) => fn(_stack));
        return id;
    },
    close(id) {
        _stack = _stack.filter((s) => s.id !== id);
        _listeners.forEach((fn) => fn(_stack));
    },
    closeAll() {
        _stack = [];
        _listeners.forEach((fn) => fn(_stack));
    },
    get() { return _stack; },
    subscribe(fn) {
        _listeners.add(fn);
        return () => _listeners.delete(fn);
    }
};

export { StackAPI };

export default function QuickPopupStackManager() {
    const [stack, setStack] = useState(_stack);

    useEffect(() => StackAPI.subscribe(setStack), []);

    const handleClose = useCallback((id) => () => StackAPI.close(id), []);

    return (
        <React.Fragment>
            {stack.map((entry, idx) => {
                const reg = QuickPopupRegistry.get(entry.table);
                if (!reg) return null;
                const Comp = reg.Component;
                const offset = idx * 16;
                return (
                    <div key={entry.id} style={{ position: 'fixed', top: 0, left: 0, transform: `translate(${offset}px, ${offset}px)`, zIndex: 1500 + idx, pointerEvents: 'none' }}>
                        <div style={{ pointerEvents: 'auto' }}>
                            <Comp {...entry.props} visible={true} onClose={handleClose(entry.id)} />
                        </div>
                    </div>
                );
            })}
        </React.Fragment>
    );
}
